module.exports = __webpack_public_path__ + "static/Giri Kuncoro-07bfc49d2daff073bb0e78b735ae4c6c.jpg";